import { s as C, r as S, a as T, b as A, c as x, g as I, p as P } from "./tokens-C4KyVSzL.js";
import { A as G, I as V, R as X, S as q, d as J, e as Q, f as Z } from "./tokens-C4KyVSzL.js";
import U from "keycloak-js";
import { h as L } from "./oauth-callback-D1dy1GrA.js";
const M = 60 * 1e3, F = 300;
async function _(n) {
  if (typeof n != "object" || !n)
    return !1;
  if ("error" in n && n.error === "invalid_grant")
    return !0;
  if (!("response" in n) || !(n.response instanceof Response) || n.response.status !== 400)
    return !1;
  try {
    const r = await n.response.clone().json();
    return typeof r == "object" && !!r && "error" in r && r.error === "invalid_grant";
  } catch {
    return !1;
  }
}
function D(n) {
  var w;
  C(n.appStorageKey);
  const r = {
    realm: n.realm,
    clientId: n.clientId,
    url: n.url
  }, t = new U(r), p = (w = n.scope) != null ? w : "openid profile email";
  let s = null, a = null, c = !1, d = null, l = null;
  const m = () => {
    T(t.token, t.refreshToken, t.idToken);
  }, y = () => {
    d && (clearTimeout(d), d = null);
  }, u = () => {
    c = !1, y(), l && (document.removeEventListener("visibilitychange", l), l = null);
  }, f = () => a || (u(), S(), a = t.login().catch((e) => {
    throw a = null, e;
  }), a), K = () => {
    var i, R;
    const e = (i = t.tokenParsed) == null ? void 0 : i.exp;
    if (typeof e == "number")
      return e * 1e3;
    const o = (R = t.token) != null ? R : I();
    if (!o)
      return null;
    try {
      return P(o).exp * 1e3;
    } catch {
      return null;
    }
  }, v = () => {
    if (y(), !c)
      return;
    const e = K();
    if (!e)
      return;
    const o = Math.max(0, e - Date.now() - M);
    d = setTimeout(() => {
      k().then((i) => {
        i || u();
      }).catch(() => {
      });
    }, o);
  }, b = async () => {
    try {
      await t.updateToken(F);
      const { token: e, refreshToken: o, idToken: i } = t;
      if (!e)
        throw new Error("Token is undefined after updateToken");
      return T(e, o, i), c && v(), e;
    } catch (e) {
      if (await _(e)) {
        await f();
        return;
      }
      throw console.error(e), e;
    }
  }, k = () => s || (s = b().finally(() => {
    s = null;
  }), s), h = () => {
    u(), c = !0, v(), l = () => {
      document.visibilityState !== "visible" || !c || k().then((e) => {
        e || u();
      }).catch(() => {
      });
    }, document.addEventListener("visibilitychange", l);
  }, E = () => L() ? (S(), {}) : {
    token: I() || void 0,
    refreshToken: x() || void 0,
    idToken: A() || void 0
  }, g = async (e) => {
    try {
      return await t.init(e);
    } catch (o) {
      if (await _(o))
        return await f(), !1;
      throw o;
    }
  };
  return {
    init: async () => {
      if (t.didInitialize)
        return;
      const e = E();
      await g({
        flow: "standard",
        scope: p,
        token: e.token,
        refreshToken: e.refreshToken,
        idToken: e.idToken,
        messageReceiveTimeout: n.messageReceiveTimeout,
        checkLoginIframe: !1
      }), t.authenticated && t.token && (m(), h());
    },
    initWithCheckSso: async () => {
      var e;
      if (!t.didInitialize) {
        const o = E();
        await g({
          flow: "standard",
          onLoad: "check-sso",
          silentCheckSsoRedirectUri: (e = n.silentCheckSsoRedirectUri) != null ? e : `${window.location.origin}/silent-check-sso.html`,
          pkceMethod: "S256",
          scope: p,
          token: o.token,
          refreshToken: o.refreshToken,
          idToken: o.idToken,
          messageReceiveTimeout: n.messageReceiveTimeout,
          checkLoginIframe: !1
        });
      }
      if (t.authenticated && t.token)
        return m(), h(), t.authenticated;
      if (t.refreshToken) {
        const o = await k();
        return T(o, t.refreshToken, t.idToken), t.authenticated && o && h(), t.authenticated || !1;
      }
      return await f(), !1;
    },
    updateToken: k,
    login: f,
    logout: async () => {
      var e;
      u(), await t.logout({
        redirectUri: (e = n.postLogoutRedirectUri) != null ? e : `${window.location.origin}/logoff`
      });
    },
    getUserInfo: async (e) => e()
  };
}
export {
  G as ACCESS_TOKEN_KEY,
  V as ID_TOKEN_KEY,
  X as REFRESH_TOKEN_KEY,
  q as SUB_KEY,
  D as createAuthClient,
  J as decodeToken,
  I as getAccessToken,
  A as getIdToken,
  Q as getIsTokenExpired,
  x as getRefreshToken,
  Z as getSub,
  L as hasOAuthCallbackParams,
  P as parseToken,
  S as removeTokens,
  C as setTokenStorageAppKey,
  T as setTokens
};
//# sourceMappingURL=core.es.js.map
